<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import AttachmentsBoard from "@/components/analytics/AttachmentsBoard.vue";
</script>

<template>
  <AgentLayout full-width>
    <AttachmentsBoard />
  </AgentLayout>
</template>
